import clsx from 'clsx';
import React from 'react';

import InternationalMobileNumInput from 'components/InternationalMobileNumInput';
import useTranslation from 'hooks/useTranslation';

const InviteOperatorModalInputs = ({
  values,
  errors,
  handleChange,
  isInviteOperator,
}) => {
  const { getTranslation } = useTranslation(['OPERATORS', 'COMMON']);
  const { t } = getTranslation();

  const handleChangeMobileInput = (value) => {
    handleChange({ target: { value, name: 'mobile' } });
  };

  return (
    <div className='modal__container__body__invite__form__agentinfo grid'>
      <div className='form-control'>
        <input
          type='text'
          name='position'
          value={values.position}
          onChange={handleChange}
          className={clsx(errors.position && 'has-error')}
          placeholder={t('OPERATOR_MODAL_FORM_TITLE')}
          required
          autoFocus
        />
        {errors.position && <div className='error'>{errors.position}</div>}
      </div>
      <div className='form-control'>
        <input
          type='text'
          name='fullName'
          value={values.fullName}
          onChange={handleChange}
          className={clsx(errors.fullName && 'has-error')}
          placeholder={t('OPERATOR_MODAL_FORM_FULLNAME')}
          required
        />
        {errors.fullName && <div className='error'>{errors.fullName}</div>}
      </div>
      <div className='form-control'>
        {isInviteOperator && (
          <>
            <input
              type='email'
              name='email'
              value={values.email}
              onChange={handleChange}
              className={clsx(errors.email && 'has-error')}
              placeholder={t('OPERATOR_MODAL_FORM_EMAIL')}
              required
            />
            {errors.email && <div className='error'>{errors.email}</div>}
          </>
        )}
        {!isInviteOperator && (
          <>
            <input
              type='email'
              name='email'
              value={values.email}
              onChange={handleChange}
              placeholder={t('OPERATOR_MODAL_FORM_EMAIL')}
              required
              disabled
              readOnly
            />
          </>
        )}
      </div>
      <div className='form-control'>
        {/* <input
          type='text'
          name='mobile'
          value={values.mobile}
          onChange={handleChange}
          className={clsx(errors.mobile && 'has-error')}
          placeholder={t('MOBILE_FIELD_PLACEHOLDER')}
          required
        /> */}
        <InternationalMobileNumInput
          onChangeInput={handleChangeMobileInput}
          value={values.mobile}
          error={errors.mobile}
        />
        {errors.mobile && <div className='error'>{errors.mobile}</div>}
      </div>
      <div className='form-control'>
        <input
          type='password'
          name='password'
          value={values.password}
          onChange={handleChange}
          className={clsx(errors.password && 'has-error')}
          placeholder={t('OPERATOR_MODAL_FORM_PASSWORD')}
          required
        />
        {errors.password && <div className='error'>{errors.password}</div>}
      </div>
      <div className='form-control'>
        <input
          type='password'
          name='confirmPassword'
          value={values.confirmPassword}
          onChange={handleChange}
          className={clsx(errors.confirmPassword && 'has-error')}
          placeholder={t('OPERATOR_MODAL_FORM_PASSWORD_CONFIRM')}
          required
        />
        {errors.confirmPassword && (
          <div className='error'>{errors.confirmPassword}</div>
        )}
      </div>
    </div>
  );
};

export default InviteOperatorModalInputs;
